import { render, staticRenderFns } from "./ResponsavelRetirada.vue?vue&type=template&id=0a759c9b&"
import script from "./ResponsavelRetirada.vue?vue&type=script&lang=js&"
export * from "./ResponsavelRetirada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports